import React from "react";
import PropTypes from "prop-types";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import _debounce from "lodash/debounce";
import { Form } from "semantic-ui-react";
import { DateRangePicker } from "../../../../components/DateRangePicker";
import FieldHeader from "../../components/Header";

function DateRangeWidget({
  id,
  required,
  readonly,
  disabled,
  name,
  label,
  schema,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  formContext,
  uiSchema,
  rawErrors = [],
  errorSchema,
  ...other
}: any) {
  const { t } = useSchemaTranslation();

  const schemaFormat = (schema.format || schema.properties?.start?.format) as "date" | "time" | "date-time" || "date-time";

  const requiredProps = schema.required || [];

  const {
    minDate,
    maxDate,
    defaultTimeType,
    autoSelectTime = true,
    semanticHeader,
    inline
  } = options

  if (!schema.properties || !schema.properties.start || !schema.properties.end) {
    return <div> [DateRangeWidget]: Missing start or end property  </div>
  };

  return (
    <Form.Field required={required}>
      {label && <FieldHeader content={t(label)} semanticProps={semanticHeader || { size: undefined }} />}
      <DateRangePicker
        key={id}
        value={value}
        onChange={onChange}
        minDate={minDate === true ? new Date().toISOString() : minDate}
        maxDate={maxDate === true ? new Date().toISOString() : maxDate}
        autoSelectTime={autoSelectTime}
        format={schemaFormat}
        start={{ required: requiredProps.includes("start"), errors: errorSchema?.start?.__errors }}
        end={{ required: requiredProps.includes("end"), errors: errorSchema?.end?.__errors }}
        inline={inline}
      />
    </Form.Field>
  );


}

DateRangeWidget.defaultProps = {
  options: {
    semantic: {
      fluid: true,
      inverted: false,
    },
  },
};

DateRangeWidget.propTypes = {
  options: PropTypes.object,
};

export default DateRangeWidget